




















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch, Mixins } from "vue-property-decorator";
import PrefillMixin from "@/mixins/PrefillMixin";
import DokterAutoComplete from "@/components/pemeriksaan/assesmen/DokterAutoComplete.vue";
import PerawatAutoComplete from "@/components/pemeriksaan/assesmen/PerawatAutoComplete.vue";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import { storeChecklistKeselamatanOperasi } from "@/store/modules/ChecklistKeselamatanOperasiStore";
import ChecklistKeselamatanOperasiSvc from "@/services/ChecklistKeselamatanOperasi";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { alasanTtdMengunciHapus } from "@/utils/hapusSetelahTtd";
import { storePerawat } from "@/store/modules/perawat";
import { storeDokter } from "@/store/modules/dokter";

@Component({
  components: {
    DokterAutoComplete,
    PerawatAutoComplete,
    CardModalTtd
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class ChecklistKeselamatanOperasiPage extends Mixins(PrefillMixin) {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop({ default: false }) isActive!: boolean;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  // ── Soft-prefill (FormPrefill engine) ──────────────────────────────
  prefillFormKey = "checklist_keselamatan_operasi";

  prefillResolvePath(path: string) {
    switch (path) {
      case "diagnosa_pre_op":
        return {
          get: () => this.form.diagnosa_pre_op,
          set: (v) => {
            this.form.diagnosa_pre_op = v;
          }
        };
      case "to_asa_ps":
        return {
          get: () => this.form.to_asa_ps,
          set: (v) => {
            this.form.to_asa_ps = v;
          }
        };
      default:
        return { get: () => "__skip__", set: () => undefined };
    }
  }
  // ───────────────────────────────────────────────────────────────────

  isFormOpen = false;
  isCreating = false;
  editingId: number | null = null;
  saving = false;
  stepperStep = 1;

  menuSignInPukul = false;
  menuTimeOutPukul = false;
  menuSignOutPukul = false;

  modalTtd = false;
  signRole = "";

  signRoles = [
    { role: "anestesi_sign_in", label: "TTD Anestesi (Sign In)", color: "teal", phase: "sign_in" },
    { role: "nurse_sign_in", label: "TTD Circulating Nurse (Sign In)", color: "indigo", phase: "sign_in" },
    { role: "time_out_operator", label: "TTD DPJP Bedah (Time-Out)", color: "deep-orange", phase: "time_out" },
    { role: "time_out_anestesi", label: "TTD DPJP Anestesi (Time-Out)", color: "deep-orange darken-2", phase: "time_out" },
    { role: "time_out_sirkuler", label: "TTD Sirkuler (Time-Out)", color: "orange darken-2", phase: "time_out" },
    { role: "time_out_scrub", label: "TTD Scrub 1 (Time-Out)", color: "amber darken-3", phase: "time_out" },
    { role: "time_out_sirkuler_2", label: "TTD Scrub 2 (Time-Out)", color: "orange darken-4", phase: "time_out" },
    { role: "operator_sign_out", label: "TTD Operator (Sign Out)", color: "green darken-1", phase: "sign_out" },
    { role: "anestesi_sign_out", label: "TTD Anestesi (Sign Out)", color: "teal darken-1", phase: "sign_out" },
    { role: "nurse_sign_out", label: "TTD Circulating Nurse (Sign Out)", color: "indigo darken-1", phase: "sign_out" }
  ];

  form: any = this.getEmptyForm();

  // ==================== Data Definitions ====================

  signInKonfirmasiItems = [
    { key: "konfirmasi_identitas", label: "Identifikasi dan gelang pasien" },
    { key: "konfirmasi_prosedur", label: "Prosedur" },
    { key: "konfirmasi_lokasi", label: "Lokasi operasi" },
    { key: "informed_consent_anestesi", label: "Informed Consent Anestesi" },
    { key: "informed_consent_operasi", label: "Informed Consent Operasi" }
  ];

  signInCheckItems = [
    { key: "konfirmasi_identitas", label: "Identifikasi pasien" },
    { key: "konfirmasi_prosedur", label: "Prosedur" },
    { key: "konfirmasi_lokasi", label: "Lokasi operasi" },
    { key: "informed_consent_anestesi", label: "Consent Anestesi" },
    { key: "informed_consent_operasi", label: "Consent Operasi" },
    { key: "penandaan_lokasi", label: "Penandaan lokasi" },
    { key: "mesin_obat_anestesi", label: "Mesin anestesi" },
    { key: "pulse_oximeter", label: "Pulse oximeter" },
    { key: "akses_iv_terpasang", label: "Akses IV" }
  ];

  timeOutCheckItems = [
    { key: "perkenalan_tim", label: "Perkenalan tim" },
    { key: "konfirmasi_nama", label: "Konfirmasi nama" },
    { key: "konfirmasi_prosedur", label: "Konfirmasi prosedur" },
    { key: "konfirmasi_lokasi_insisi", label: "Konfirmasi lokasi insisi" },
    { key: "antibiotik_profilaksis", label: "Antibiotik profilaksis" },
    { key: "review_bedah_sudah", label: "Review dokter bedah" },
    { key: "review_anestesi_sudah", label: "Review tim anestesi" },
    { key: "peralatan_steril", label: "Peralatan steril" },
    { key: "cek_alat_implant", label: "Cek alat/implant" },
    { key: "foto_ditayangkan", label: "Foto imaging" }
  ];

  signOutCheckItems = [
    { key: "nama_prosedur_dicatat", label: "Prosedur dicatat" },
    { key: "instrumen_sponge_jarum_dihitung", label: "Instrumen dihitung" },
    { key: "spesimen_label", label: "Spesimen dilabel" },
    { key: "masalah_peralatan", label: "Masalah peralatan" }
  ];

  instrumenItems = [
    { key: "jarum", label: "Jarum" },
    { key: "kasa", label: "Kasa / Sponge" },
    { key: "instrument", label: "Instrument" }
  ];

  // ===== Time-Out structured master data (spec v1.0.0) =====
  awareItems = [
    { text: "Access", value: "access" },
    { text: "Watch", value: "watch" },
    { text: "Reserve", value: "reserve" },
    { text: "Unknown", value: "unknown" }
  ];

  ruteItems = [
    { text: "IV", value: "iv" },
    { text: "IM", value: "im" },
    { text: "PO", value: "po" },
    { text: "SC", value: "sc" },
    { text: "Topikal", value: "topikal" },
    { text: "Inhalasi", value: "inhalasi" }
  ];

  lukaItems = [
    { text: "Bersih (Class 1)", value: "bersih" },
    { text: "Bersih-Terkontaminasi (Class 2)", value: "bersih_terkontaminasi" },
    { text: "Terkontaminasi (Class 3)", value: "terkontaminasi" },
    { text: "Kotor (Class 4)", value: "kotor" }
  ];

  imagingJenisItems = [
    { text: "Rontgen", value: "rontgen" },
    { text: "CT", value: "ct" },
    { text: "MRI", value: "mri" },
    { text: "USG", value: "usg" },
    { text: "Angiografi", value: "angiografi" },
    { text: "Fluoroskopi", value: "fluoroskopi" },
    { text: "PET", value: "pet" }
  ];

  antiseptikItems = [
    { text: "CHG + Alkohol 70%", value: "chg_alkohol" },
    { text: "Povidon-Iodine + Alkohol", value: "povidon_iodine_alkohol" },
    { text: "Iodine Tincture", value: "iodine_tincture" },
    { text: "Lainnya", value: "lainnya" }
  ];

  penghangatanItems = [
    { text: "Forced-air warming", value: "forced_air_warming" },
    { text: "Cairan IV hangat", value: "cairan_iv_hangat" },
    { text: "Penghangat ruangan", value: "penghangat_ruangan" },
    { text: "Tidak ada", value: "tidak_ada" },
    { text: "Lainnya", value: "lainnya" }
  ];

  jenisAnestesiItems = [
    { text: "Umum (General)", value: "umum" },
    { text: "Regional - Spinal", value: "regional_spinal" },
    { text: "Regional - Epidural", value: "regional_epidural" },
    { text: "Regional - Blok", value: "regional_blok" },
    { text: "Lokal", value: "lokal" },
    { text: "Sedasi Sadar", value: "sedasi" }
  ];

  // ==================== Lifecycle ====================

  mounted() {
    storeChecklistKeselamatanOperasi.getByRegister(this.register);
    if (!storePerawat.listPerawat.length) storePerawat.actListPerawatall();
    if (!storeDokter.listAll.length) storeDokter.act_dokter_all();
  }

  // ==================== Empty Form ====================

  getEmptyForm() {
    return {
      sign_in_pukul: "",
      diagnosa_pre_op: "",
      anestesi_sign_in_user_id: null,
      anestesi_sign_in_obj: null,
      nurse_sign_in_user_id: null,
      nurse_sign_in_obj: null,
      sign_in_content: {
        konfirmasi_identitas: null,
        konfirmasi_prosedur: null,
        konfirmasi_lokasi: null,
        informed_consent_anestesi: null,
        informed_consent_operasi: null,
        penandaan_lokasi: null,
        mesin_obat_anestesi: null,
        pulse_oximeter: null,
        riwayat_alergi: null,
        alergi_detail: "",
        kesulitan_nafas_aspirasi: null,
        kesulitan_nafas_detail: "",
        risiko_perdarahan_500ml: null,
        akses_iv_terpasang: null,
        rencana_terapi_cairan: "",
        membutuhkan_implant: null,
        implant_disiapkan: null
      },
      time_out_pukul: "",
      time_out_content: {
        perkenalan_tim: null,
        konfirmasi_nama: null,
        konfirmasi_prosedur: null,
        konfirmasi_lokasi_insisi: null,
        antibiotik_profilaksis: null,
        antibiotik_nama: "",
        antibiotik_dosis: "",
        review_bedah_sudah: null,
        review_anestesi_sudah: null,
        peralatan_steril: null,
        cek_alat_implant: null,
        foto_ditayangkan: null
      },
      // Time-Out structured (spec v1.0.0)
      to_site_marking_verified: null,
      to_sisi_operasi: "",
      to_diskrepansi_catatan: "",
      to_antibiotik_status: null,
      to_antibiotik_nama_generik: "",
      to_antibiotik_nama_dagang: "",
      to_antibiotik_aware_kategori: null,
      to_antibiotik_dosis_value: null,
      to_antibiotik_dosis_unit: null,
      to_antibiotik_rute: null,
      to_antibiotik_jam: null,
      to_antibiotik_alasan_tidak: "",
      to_antibiotik_indikasi: "",
      to_klasifikasi_luka: null,
      to_surgeon_langkah_kritis: "",
      to_surgeon_durasi_menit: null,
      to_surgeon_ebl_ml: null,
      to_surgeon_darah_disiapkan: null,
      to_anes_hal_khusus: "",
      to_anes_difficult_airway: null,
      to_anes_risiko_aspirasi: null,
      to_anes_rencana_nyeri_pasca_op: "",
      to_nurse_alat_khusus: "",
      to_nurse_implan_tersedia: null,
      to_nurse_implan_barcode_tercatat: null,
      to_imaging_jenis: [],
      to_imaging_alasan_tidak: "",
      to_ssi_skin_prep_alkohol: null,
      to_ssi_skin_prep_antiseptik: null,
      to_ssi_skin_prep_pengeringan_cukup: null,
      to_ssi_normothermia: null,
      to_ssi_suhu_pre_insisi: null,
      to_ssi_metode_penghangatan: [],
      to_ssi_glukosa_terkontrol: null,
      to_ssi_gds_pre_op: null,
      to_ssi_pasien_dm: null,
      to_ssi_insulin_diberikan: null,
      to_asa_ps: null,
      to_asa_emergency: null,
      to_jenis_anestesi: null,
      to_status: "tertunda",
      to_clear_to_incise: null,
      to_jam_selesai: null,
      time_out_operator_user_id: null,
      time_out_operator_obj: null,
      time_out_anestesi_user_id: null,
      time_out_anestesi_obj: null,
      time_out_sirkuler_user_id: null,
      time_out_sirkuler_obj: null,
      time_out_sirkuler_2_user_id: null,
      time_out_sirkuler_2_obj: null,
      time_out_scrub_user_id: null,
      time_out_scrub_obj: null,
      sign_out_pukul: "",
      diagnosa_post_op: "",
      sign_out_content: {
        nama_prosedur_dicatat: null,
        instrumen_sponge_jarum_dihitung: null,
        spesimen_label: null,
        masalah_peralatan: null
      },
      penghitungan_instrumen: {
        jarum: { pra: 0, intra: 0, pasca: 0 },
        kasa: { pra: 0, intra: 0, pasca: 0 },
        instrument: { pra: 0, intra: 0, pasca: 0 }
      },
      review_manajemen: "",
      operator_sign_out_user_id: null,
      operator_obj: null,
      anestesi_sign_out_user_id: null,
      anestesi_out_obj: null,
      nurse_sign_out_user_id: null,
      nurse_out_obj: null
    };
  }

  // ==================== Computed ====================

  get stateData() { return storeChecklistKeselamatanOperasi.data; }
  get stateLoading() { return storeChecklistKeselamatanOperasi.loading; }
  get stateuser() { return userModule.user; }

  get isSignInSaved(): boolean {
    return this.stateData && !!this.stateData.sign_in_content;
  }

  get isTimeOutSaved(): boolean {
    return this.stateData && !!this.stateData.time_out_content && !!this.stateData.time_out_pukul;
  }

  get isSignOutSaved(): boolean {
    return this.stateData && !!this.stateData.sign_out_content;
  }

  get canEdit(): boolean {
    return !this.readOnly && !!this.stateData;
  }

  get canDelete(): boolean {
    if (this.readOnly || !this.stateData) return false;
    const data = this.stateData;
    return !alasanTtdMengunciHapus(
      data.creator_user_id,
      this.signRoles.map(s => ({ ditandatangani: data["signed_" + s.role], penandaTanganId: data[s.role + "_user_id"] })),
      userModule.user?.id
    );
  }

  // Navigation
  get canNavSignIn(): boolean { return true; }
  get canNavTimeOut(): boolean { return this.isSignInSaved; }
  get canNavSignOut(): boolean { return this.isTimeOutSaved; }

  // Form validation
  get isSignInFormValid(): boolean {
    return !!this.form.sign_in_pukul;
  }

  get isTimeOutFormValid(): boolean {
    return !!this.form.time_out_pukul
      && !!this.form.time_out_operator_user_id
      && !!this.form.time_out_anestesi_user_id
      && !!this.form.time_out_sirkuler_user_id
      && !!this.form.time_out_scrub_user_id;
  }

  // ==================== Tanda Tangan ====================

  get availableSignButtons() {
    if (!this.stateData) return [];
    return this.signRoles.filter(s => this.canSignRole(s));
  }

  canSignRole(s): boolean {
    const d = this.stateData;
    if (!d || d[`signed_${s.role}`]) return false;

    if (s.phase === "sign_in" && !d.sign_in_content) return false;
    if (s.phase === "time_out" && (!d.time_out_content || !d.time_out_pukul)) return false;
    if (s.phase === "sign_out" && !d.sign_out_content) return false;
    if (s.role === "time_out_sirkuler_2" && !d.time_out_sirkuler_2_user_id) return false;

    const ditunjuk = d[`${s.role}_user_id`];
    if (!ditunjuk) return true;

    return !!this.stateuser && String(ditunjuk) === String(this.stateuser.id);
  }

  ttdMark(role: string): string {
    return this.stateData?.[`signed_${role}`] ? " (TTD ✓)" : "";
  }

  openTtd(role: string) {
    this.signRole = role;
    this.modalTtd = true;
  }

  async passTtd(password) {
    if (!this.stateData || !this.signRole) return;

    const svc = ChecklistKeselamatanOperasiSvc;
    const fnByRole = {
      anestesi_sign_in: svc.signAnestesiIn,
      nurse_sign_in: svc.signNurseIn,
      time_out_operator: svc.signTimeOutOperator,
      time_out_anestesi: svc.signTimeOutAnestesi,
      time_out_sirkuler: svc.signTimeOutSirkuler,
      time_out_sirkuler_2: svc.signTimeOutSirkuler2,
      time_out_scrub: svc.signTimeOutScrub,
      operator_sign_out: svc.signOperatorOut,
      anestesi_sign_out: svc.signAnestesiOut,
      nurse_sign_out: svc.signNurseOut
    };

    const fn = fnByRole[this.signRole];
    if (!fn) return;

    try {
      const resp = await fn(this.stateData.id, { password });
      if (resp.data.status == "1") {
        appModule.NoticeDelay(resp.data.message || "Berhasil menandatangani");
        await storeChecklistKeselamatanOperasi.getByRegister(this.register);
      }
    } catch {
      // pesan error sudah ditampilkan service
    } finally {
      this.signRole = "";
    }
  }

  notifySignaturesInvalidated(resp) {
    const roles = resp?.data?.meta?.signatures_invalidated;
    if (!roles || !roles.length) return;

    const label = roles
      .map(r => {
        const found = this.signRoles.find(s => s.role === r);
        return found ? found.label.replace("TTD ", "") : r;
      })
      .join(", ");

    appModule.sendErrorAlert(
      `TTD ${label} dibatalkan karena anggota tim diganti — mohon tanda tangan ulang.`
    );
  }

  get isSignOutFormValid(): boolean {
    return !!this.form.sign_out_pukul
      && !!this.form.operator_sign_out_user_id
      && !!this.form.anestesi_sign_out_user_id
      && !!this.form.nurse_sign_out_user_id;
  }

  // Instrumen mismatch
  formInstrumenMismatch(key: string): boolean {
    const item = this.form.penghitungan_instrumen[key];
    if (!item) return false;
    const pra = Number(item.pra);
    const pasca = Number(item.pasca);
    if (isNaN(pra) || isNaN(pasca)) return false;
    return pra !== pasca;
  }

  get anyFormInstrumenMismatch(): boolean {
    return this.instrumenItems.some(i => this.formInstrumenMismatch(i.key));
  }

  instrumenMismatch(key: string): boolean {
    if (!this.stateData?.penghitungan_instrumen) return false;
    const item = this.stateData.penghitungan_instrumen[key];
    if (!item) return false;
    return Number(item.pra) !== Number(item.pasca);
  }

  get anyInstrumenMismatch(): boolean {
    return this.instrumenItems.some(i => this.instrumenMismatch(i.key));
  }

  getInstrumen(key: string, phase: string): string {
    if (!this.stateData?.penghitungan_instrumen?.[key]) return "";
    const val = this.stateData.penghitungan_instrumen[key][phase];
    return val !== null && val !== undefined ? String(val) : "";
  }

  // ==================== Helpers ====================

  boolColor(val) {
    if (val === true) return "green";
    if (val === false) return "red";
    return "grey";
  }

  boolIcon(val) {
    if (val === true) return "mdi-check-circle";
    if (val === false) return "mdi-close-circle";
    return "mdi-minus-circle";
  }

  awareChipColor(kategori) {
    if (kategori === "access") return "green";
    if (kategori === "watch") return "orange";
    if (kategori === "reserve") return "red";
    return "grey";
  }

  setAnestesiIn(d) {
    this.form.anestesi_sign_in_user_id = d ? d.id : null;
    this.form.anestesi_sign_in_obj = d || null;
  }

  setNurseIn(p) {
    this.form.nurse_sign_in_user_id = p ? p.id : null;
    this.form.nurse_sign_in_obj = p || null;
  }

  setOperator(dokter) {
    this.form.operator_sign_out_user_id = dokter ? dokter.id : null;
    this.form.operator_obj = dokter || null;
  }

  setTimeOutOperator(d) {
    this.form.time_out_operator_user_id = d ? d.id : null;
    this.form.time_out_operator_obj = d || null;
  }

  setTimeOutAnestesi(d) {
    this.form.time_out_anestesi_user_id = d ? d.id : null;
    this.form.time_out_anestesi_obj = d || null;
  }

  setTimeOutSirkuler(p) {
    this.form.time_out_sirkuler_user_id = p ? p.id : null;
    this.form.time_out_sirkuler_obj = p || null;
  }

  setTimeOutSirkuler2(p) {
    this.form.time_out_sirkuler_2_user_id = p ? p.id : null;
    this.form.time_out_sirkuler_2_obj = p || null;
  }

  setTimeOutScrub(p) {
    this.form.time_out_scrub_user_id = p ? p.id : null;
    this.form.time_out_scrub_obj = p || null;
  }

  setAnestesiOut(dokter) {
    this.form.anestesi_sign_out_user_id = dokter ? dokter.id : null;
    this.form.anestesi_out_obj = dokter || null;
  }

  setNurseOut(perawat) {
    this.form.nurse_sign_out_user_id = perawat ? perawat.id : null;
    this.form.nurse_out_obj = perawat || null;
  }

  // ==================== Actions ====================

  startCreate() {
    this.form = this.getEmptyForm();
    const now = new Date();
    this.form.sign_in_pukul = now.toTimeString().substring(0, 5);
    this.stepperStep = 1;
    this.isCreating = true;
    this.editingId = null;
    // Soft-prefill dx pre-op + ASA dari APB register ini (field kosong saja;
    // tombol startCreate sudah digating readOnly).
    this.$nextTick(() => {
      this.loadPrefill({
        pasien_rm: String(this.rm),
        register_id: this.register,
        unit_id: userModule.user ? userModule.user.unit_id : undefined
      });
    });
    this.isFormOpen = true;
  }

  startEdit() {
    const d = this.stateData;
    this.form = {
      sign_in_pukul: d.sign_in_pukul || "",
      diagnosa_pre_op: d.diagnosa_pre_op || "",
      anestesi_sign_in_user_id: d.anestesi_sign_in_user_id,
      anestesi_sign_in_obj: d.anestesi_sign_in_nama ? { id: d.anestesi_sign_in_user_id, nama: d.anestesi_sign_in_nama } : null,
      nurse_sign_in_user_id: d.nurse_sign_in_user_id,
      nurse_sign_in_obj: d.nurse_sign_in_nama ? { id: d.nurse_sign_in_user_id, nama: d.nurse_sign_in_nama } : null,
      sign_in_content: d.sign_in_content ? { ...d.sign_in_content } : this.getEmptyForm().sign_in_content,
      time_out_pukul: d.time_out_pukul || "",
      time_out_content: d.time_out_content ? { ...d.time_out_content } : this.getEmptyForm().time_out_content,
      to_site_marking_verified: d.to_site_marking_verified ?? null,
      to_sisi_operasi: d.to_sisi_operasi || "",
      to_diskrepansi_catatan: d.to_diskrepansi_catatan || "",
      to_antibiotik_status: d.to_antibiotik_status ?? null,
      to_antibiotik_nama_generik: d.to_antibiotik_nama_generik || "",
      to_antibiotik_nama_dagang: d.to_antibiotik_nama_dagang || "",
      to_antibiotik_aware_kategori: d.to_antibiotik_aware_kategori ?? null,
      to_antibiotik_dosis_value: d.to_antibiotik_dosis_value ?? null,
      to_antibiotik_dosis_unit: d.to_antibiotik_dosis_unit ?? null,
      to_antibiotik_rute: d.to_antibiotik_rute ?? null,
      to_antibiotik_jam: d.to_antibiotik_jam ?? null,
      to_antibiotik_alasan_tidak: d.to_antibiotik_alasan_tidak || "",
      to_antibiotik_indikasi: d.to_antibiotik_indikasi || "",
      to_klasifikasi_luka: d.to_klasifikasi_luka ?? null,
      to_surgeon_langkah_kritis: d.to_surgeon_langkah_kritis || "",
      to_surgeon_durasi_menit: d.to_surgeon_durasi_menit ?? null,
      to_surgeon_ebl_ml: d.to_surgeon_ebl_ml ?? null,
      to_surgeon_darah_disiapkan: d.to_surgeon_darah_disiapkan ?? null,
      to_anes_hal_khusus: d.to_anes_hal_khusus || "",
      to_anes_difficult_airway: d.to_anes_difficult_airway ?? null,
      to_anes_risiko_aspirasi: d.to_anes_risiko_aspirasi ?? null,
      to_anes_rencana_nyeri_pasca_op: d.to_anes_rencana_nyeri_pasca_op || "",
      to_nurse_alat_khusus: d.to_nurse_alat_khusus || "",
      to_nurse_implan_tersedia: d.to_nurse_implan_tersedia ?? null,
      to_nurse_implan_barcode_tercatat: d.to_nurse_implan_barcode_tercatat ?? null,
      to_imaging_jenis: d.to_imaging_jenis ? [...d.to_imaging_jenis] : [],
      to_imaging_alasan_tidak: d.to_imaging_alasan_tidak || "",
      to_ssi_skin_prep_alkohol: d.to_ssi_skin_prep_alkohol ?? null,
      to_ssi_skin_prep_antiseptik: d.to_ssi_skin_prep_antiseptik ?? null,
      to_ssi_skin_prep_pengeringan_cukup: d.to_ssi_skin_prep_pengeringan_cukup ?? null,
      to_ssi_normothermia: d.to_ssi_normothermia ?? null,
      to_ssi_suhu_pre_insisi: d.to_ssi_suhu_pre_insisi ?? null,
      to_ssi_metode_penghangatan: d.to_ssi_metode_penghangatan ? [...d.to_ssi_metode_penghangatan] : [],
      to_ssi_glukosa_terkontrol: d.to_ssi_glukosa_terkontrol ?? null,
      to_ssi_gds_pre_op: d.to_ssi_gds_pre_op ?? null,
      to_ssi_pasien_dm: d.to_ssi_pasien_dm ?? null,
      to_ssi_insulin_diberikan: d.to_ssi_insulin_diberikan ?? null,
      to_asa_ps: d.to_asa_ps ?? null,
      to_asa_emergency: d.to_asa_emergency ?? null,
      to_jenis_anestesi: d.to_jenis_anestesi ?? null,
      to_status: d.to_status || "tertunda",
      to_clear_to_incise: d.to_clear_to_incise ?? null,
      to_jam_selesai: d.to_jam_selesai ?? null,
      time_out_operator_user_id: d.time_out_operator_user_id,
      time_out_operator_obj: d.time_out_operator_nama ? { id: d.time_out_operator_user_id, nama: d.time_out_operator_nama } : null,
      time_out_anestesi_user_id: d.time_out_anestesi_user_id,
      time_out_anestesi_obj: d.time_out_anestesi_nama ? { id: d.time_out_anestesi_user_id, nama: d.time_out_anestesi_nama } : null,
      time_out_sirkuler_user_id: d.time_out_sirkuler_user_id,
      time_out_sirkuler_obj: d.time_out_sirkuler_nama ? { id: d.time_out_sirkuler_user_id, nama: d.time_out_sirkuler_nama } : null,
      time_out_sirkuler_2_user_id: d.time_out_sirkuler_2_user_id,
      time_out_sirkuler_2_obj: d.time_out_sirkuler_2_nama ? { id: d.time_out_sirkuler_2_user_id, nama: d.time_out_sirkuler_2_nama } : null,
      time_out_scrub_user_id: d.time_out_scrub_user_id,
      time_out_scrub_obj: d.time_out_scrub_nama ? { id: d.time_out_scrub_user_id, nama: d.time_out_scrub_nama } : null,
      sign_out_pukul: d.sign_out_pukul || "",
      diagnosa_post_op: d.diagnosa_post_op || "",
      sign_out_content: d.sign_out_content ? { ...d.sign_out_content } : this.getEmptyForm().sign_out_content,
      penghitungan_instrumen: d.penghitungan_instrumen
        ? JSON.parse(JSON.stringify(d.penghitungan_instrumen))
        : this.getEmptyForm().penghitungan_instrumen,
      review_manajemen: d.review_manajemen || "",
      operator_sign_out_user_id: d.operator_sign_out_user_id,
      operator_obj: d.operator_sign_out_nama ? { id: d.operator_sign_out_user_id, nama: d.operator_sign_out_nama } : null,
      anestesi_sign_out_user_id: d.anestesi_sign_out_user_id,
      anestesi_out_obj: d.anestesi_sign_out_nama ? { id: d.anestesi_sign_out_user_id, nama: d.anestesi_sign_out_nama } : null,
      nurse_sign_out_user_id: d.nurse_sign_out_user_id,
      nurse_out_obj: d.nurse_sign_out_nama ? { id: d.nurse_sign_out_user_id, nama: d.nurse_sign_out_nama } : null
    };

    // Navigate to first incomplete step
    if (!d.sign_in_content) {
      this.stepperStep = 1;
    } else if (!d.time_out_content || !d.time_out_pukul) {
      this.stepperStep = 2;
    } else if (!d.sign_out_content) {
      this.stepperStep = 3;
    } else {
      this.stepperStep = 3;
    }

    this.isCreating = false;
    this.editingId = d.id;
    this.isFormOpen = true;
  }

  cancelForm() {
    this.isFormOpen = false;
    this.isCreating = false;
    this.editingId = null;
    this.form = this.getEmptyForm();
  }

  async simpanSignIn() {
    this.saving = true;
    try {
      const payload = {
        register_id: this.register,
        pasien_rm: this.rm,
        sign_in_pukul: this.form.sign_in_pukul,
        diagnosa_pre_op: this.form.diagnosa_pre_op,
        sign_in_content: this.form.sign_in_content,
        anestesi_sign_in_user_id: this.form.anestesi_sign_in_user_id,
        nurse_sign_in_user_id: this.form.nurse_sign_in_user_id
      };

      let resp;
      if (this.isCreating && !this.editingId) {
        resp = await ChecklistKeselamatanOperasiSvc.create(payload);
        if (resp.data.status == "1") {
          this.editingId = resp.data.data.id;
          this.isCreating = false;
        }
      } else {
        resp = await ChecklistKeselamatanOperasiSvc.updateSignIn(this.editingId, payload);
      }

      if (resp.data.status == "1") {
        appModule.NoticeDelay("Sign In tersimpan.");
        this.notifySignaturesInvalidated(resp);
        await storeChecklistKeselamatanOperasi.getByRegister(this.register);
        this.stepperStep = 2;
      }
    } finally {
      this.saving = false;
    }
  }

  async simpanTimeOut() {
    this.saving = true;
    try {
      const payload = {
        register_id: this.register,
        pasien_rm: this.rm,
        time_out_pukul: this.form.time_out_pukul,
        time_out_content: this.form.time_out_content,
        // Time-Out structured (spec v1.0.0)
        to_site_marking_verified: this.form.to_site_marking_verified,
        to_sisi_operasi: this.form.to_sisi_operasi,
        to_diskrepansi_catatan: this.form.to_diskrepansi_catatan,
        to_antibiotik_status: this.form.to_antibiotik_status,
        to_antibiotik_nama_generik: this.form.to_antibiotik_nama_generik,
        to_antibiotik_nama_dagang: this.form.to_antibiotik_nama_dagang,
        to_antibiotik_aware_kategori: this.form.to_antibiotik_aware_kategori,
        to_antibiotik_dosis_value: this.form.to_antibiotik_dosis_value,
        to_antibiotik_dosis_unit: this.form.to_antibiotik_dosis_unit,
        to_antibiotik_rute: this.form.to_antibiotik_rute,
        to_antibiotik_jam: this.form.to_antibiotik_jam,
        to_antibiotik_alasan_tidak: this.form.to_antibiotik_alasan_tidak,
        to_antibiotik_indikasi: this.form.to_antibiotik_indikasi,
        to_klasifikasi_luka: this.form.to_klasifikasi_luka,
        to_surgeon_langkah_kritis: this.form.to_surgeon_langkah_kritis,
        to_surgeon_durasi_menit: this.form.to_surgeon_durasi_menit,
        to_surgeon_ebl_ml: this.form.to_surgeon_ebl_ml,
        to_surgeon_darah_disiapkan: this.form.to_surgeon_darah_disiapkan,
        to_anes_hal_khusus: this.form.to_anes_hal_khusus,
        to_anes_difficult_airway: this.form.to_anes_difficult_airway,
        to_anes_risiko_aspirasi: this.form.to_anes_risiko_aspirasi,
        to_anes_rencana_nyeri_pasca_op: this.form.to_anes_rencana_nyeri_pasca_op,
        to_nurse_alat_khusus: this.form.to_nurse_alat_khusus,
        to_nurse_implan_tersedia: this.form.to_nurse_implan_tersedia,
        to_nurse_implan_barcode_tercatat: this.form.to_nurse_implan_barcode_tercatat,
        to_imaging_jenis: this.form.to_imaging_jenis,
        to_imaging_alasan_tidak: this.form.to_imaging_alasan_tidak,
        to_ssi_skin_prep_alkohol: this.form.to_ssi_skin_prep_alkohol,
        to_ssi_skin_prep_antiseptik: this.form.to_ssi_skin_prep_antiseptik,
        to_ssi_skin_prep_pengeringan_cukup: this.form.to_ssi_skin_prep_pengeringan_cukup,
        to_ssi_normothermia: this.form.to_ssi_normothermia,
        to_ssi_suhu_pre_insisi: this.form.to_ssi_suhu_pre_insisi,
        to_ssi_metode_penghangatan: this.form.to_ssi_metode_penghangatan,
        to_ssi_glukosa_terkontrol: this.form.to_ssi_glukosa_terkontrol,
        to_ssi_gds_pre_op: this.form.to_ssi_gds_pre_op,
        to_ssi_pasien_dm: this.form.to_ssi_pasien_dm,
        to_ssi_insulin_diberikan: this.form.to_ssi_insulin_diberikan,
        to_asa_ps: this.form.to_asa_ps,
        to_asa_emergency: this.form.to_asa_emergency,
        to_jenis_anestesi: this.form.to_jenis_anestesi,
        to_status: this.form.to_status,
        to_clear_to_incise: this.form.to_clear_to_incise,
        to_jam_selesai: this.form.to_jam_selesai,
        time_out_operator_user_id: this.form.time_out_operator_user_id,
        time_out_anestesi_user_id: this.form.time_out_anestesi_user_id,
        time_out_sirkuler_user_id: this.form.time_out_sirkuler_user_id,
        time_out_sirkuler_2_user_id: this.form.time_out_sirkuler_2_user_id,
        time_out_scrub_user_id: this.form.time_out_scrub_user_id
      };

      const resp = await ChecklistKeselamatanOperasiSvc.updateTimeOut(this.editingId, payload);

      if (resp.data.status == "1") {
        appModule.NoticeDelay("Time Out berhasil disimpan");
        this.notifySignaturesInvalidated(resp);
        await storeChecklistKeselamatanOperasi.getByRegister(this.register);
        this.stepperStep = 3;
      }
    } finally {
      this.saving = false;
    }
  }

  async simpanSignOut() {
    this.saving = true;
    try {
      const payload = {
        register_id: this.register,
        pasien_rm: this.rm,
        sign_out_pukul: this.form.sign_out_pukul,
        diagnosa_post_op: this.form.diagnosa_post_op,
        sign_out_content: this.form.sign_out_content,
        penghitungan_instrumen: this.form.penghitungan_instrumen,
        review_manajemen: this.form.review_manajemen,
        operator_sign_out_user_id: this.form.operator_sign_out_user_id,
        anestesi_sign_out_user_id: this.form.anestesi_sign_out_user_id,
        nurse_sign_out_user_id: this.form.nurse_sign_out_user_id
      };

      const resp = await ChecklistKeselamatanOperasiSvc.updateSignOut(this.editingId, payload);

      if (resp.data.status == "1") {
        appModule.NoticeDelay("Sign Out berhasil disimpan");
        this.notifySignaturesInvalidated(resp);
        this.cancelForm();
        storeChecklistKeselamatanOperasi.getByRegister(this.register);
      }
    } finally {
      this.saving = false;
    }
  }

  async remove() {
    if (!this.canDelete) return;
    if (!confirm("Anda yakin akan menghapus checklist keselamatan operasi ini?")) return;
    try {
      const resp = await ChecklistKeselamatanOperasiSvc.destroy(this.stateData.id);
      if (resp.data.status == 1) {
        appModule.NoticeDelay("Berhasil menghapus data");
        storeChecklistKeselamatanOperasi.getByRegister(this.register);
      }
    } catch {
      // error handled by service
    }
  }

  cetakPdf() {
    if (this.stateData) {
      ChecklistKeselamatanOperasiSvc.print(this.stateData.id);
    }
  }

  @Watch("register")
  onRegisterChange() {
    storeChecklistKeselamatanOperasi.getByRegister(this.register);
  }
}
